import { api } from '../../../lib/api'

export const GET_DOMAINS_AND_CATEGS_REQUEST = 'GET_DOMAINS_AND_CATEGS_REQUEST'
export const GET_DOMAINS_AND_CATEGS_SUCCESS = 'GET_DOMAINS_AND_CATEGS_SUCCESS'
export const GET_DOMAINS_AND_CATEGS_FAILED = 'GET_DOMAINS_AND_CATEGS_FAILED'

export const UPDATE_CATEGORY_REQUEST = 'UPDATE_CATEGORY_REQUEST'
export const UPDATE_CATEGORY_SUCCESS = 'UPDATE_CATEGORY_SUCCESS'
export const UPDATE_CATEGORY_FAILED = 'UPDATE_CATEGORY_FAILED'

export const NEW_DOMAIN_CATEGORY_REQUEST = 'NEW_DOMAIN_CATEGORY_REQUEST'
export const NEW_DOMAIN_CATEGORY_SUCCESS = 'NEW_DOMAIN_CATEGORY_SUCCESS'
export const NEW_DOMAIN_CATEGORY_FAILED = 'NEW_DOMAIN_CATEGORY_FAILED'

export const NEW_NOTIFICATION_CATEGORY_REQUEST = 'NEW_NOTIFICATION_CATEGORY_REQUEST'
export const NEW_NOTIFICATION_CATEGORY_SUCCESS = 'NEW_NOTIFICATION_CATEGORY_SUCCESS'
export const NEW_NOTIFICATION_CATEGORY_FAILED = 'NEW_NOTIFICATION_CATEGORY_FAILED'

export const DELETE_CATEGORY_REQUEST = 'DELETE_CATEGORY_REQUEST'
export const DELETE_CATEGORY_SUCCESS = 'DELETE_CATEGORY_SUCCESS'
export const DELETE_CATEGORY_FAILED = 'DELETE_CATEGORY_FAILED'

export const DELETE_NOTIFICATIONS_CATEGORY_REQUEST = 'DELETE_NOTIFICATIONS_CATEGORY_REQUEST'
export const DELETE_NOTIFICATIONS_CATEGORY_SUCCESS = 'DELETE_NOTIFICATIONS_CATEGORY_SUCCESS'
export const DELETE_NOTIFICATIONS_CATEGORY_FAILED = 'DELETE_NOTIFICATIONS_CATEGORY_FAILED'

export const getDomainsAndCategories = function () {
  return function (dispatch) {
    dispatch({
      type: GET_DOMAINS_AND_CATEGS_REQUEST
    })
    api.getDomainsAndCategories().then(response => {
      dispatch({
        type: GET_DOMAINS_AND_CATEGS_SUCCESS,
        payload: response
      })
    }).catch(error => {
      dispatch({
        type: GET_DOMAINS_AND_CATEGS_FAILED,
        error
      })
    })
  }
}

export const addDomainCategory = (data, onComplete) => {
  return (dispatch) => {
    dispatch({
      type: NEW_DOMAIN_CATEGORY_REQUEST
    })
    api.addDomainCategory(data).then(response => {
      dispatch({
        type: NEW_DOMAIN_CATEGORY_SUCCESS,
        payload: response
      })
      if (onComplete) onComplete()
    }).catch(error => {
      dispatch({
        type: NEW_DOMAIN_CATEGORY_FAILED,
        error
      })
    })
  }
}

export const addNotificationCategory = (data, onComplete) => {
  return (dispatch) => {
    dispatch({
      type: NEW_NOTIFICATION_CATEGORY_REQUEST
    })
    api.addNotificationCategory(data).then(response => {
      dispatch({
        type: NEW_NOTIFICATION_CATEGORY_SUCCESS,
        payload: response
      })
      if (onComplete) onComplete()
    }).catch(error => {
      dispatch({
        type: NEW_NOTIFICATION_CATEGORY_FAILED,
        error
      })
    })
  }
}

export const updateCategory = (category, cb) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_CATEGORY_REQUEST
    })
    api.updateCategory(category).then(response => {
      cb()
      // dispatch({
      //   type: UPDATE_CATEGORY_SUCCESS,
      //   payload: response
      // })
    }).catch(error => {
      dispatch({
        type: UPDATE_CATEGORY_FAILED,
        error
      })
    })
  }
}

export const deleteCategory = (categoryId, isNotif) => {
  return (dispatch) => {
    if (isNotif) {

      dispatch({
        type: DELETE_NOTIFICATIONS_CATEGORY_REQUEST
      })

      api.deleteNotificationsCategory(categoryId).then(response => {
        dispatch({
          type: DELETE_NOTIFICATIONS_CATEGORY_SUCCESS,
          payload: response
        })
      }).catch(error => {
        dispatch({
          type: DELETE_NOTIFICATIONS_CATEGORY_FAILED,
          error
        })
      })

    } else {

      dispatch({
        type: DELETE_CATEGORY_REQUEST
      })
      api.deleteCategory(categoryId).then(response => {
        dispatch({
          type: DELETE_CATEGORY_SUCCESS,
          payload: response
        })
      }).catch(error => {
        dispatch({
          type: DELETE_CATEGORY_FAILED,
          error
        })
      })

    }
  }
}


export const updateNotificationCategory = () => { }




// WEBPACK FOOTER //
// ./src/redux/actions/superadmin/domains-categories.js